import { IThemeProps } from 'component/theme';
import styled from 'styled-components';
import WrapperContainer from "../WrapperContainer/WrapperContainer";
import Box from '../Box/Box';

export const TOP_NAV_HEIGHT = 64;
export const SECONDARY_MENU_HEIGHT = 64;
export const TOP_NAV_MOBILE_HEIGHT = 150;
export const TOP_NAV_Z_INDEX = 1300;

export const LIST_MENU_MARGIN_LEFT = 32;
export const GROUP_MENU_ITEM_PADDING_X = 8;
export const HOME_BUTTON_MARGIN_X = 15;
export const HOME_BUTTON_MARGIN_RIGHT = HOME_BUTTON_MARGIN_X - (LIST_MENU_MARGIN_LEFT + GROUP_MENU_ITEM_PADDING_X);

export const GlobalSearchContainer: any = styled(Box)`
${( {theme, ...props} : IThemeProps) => `    
    
`}`;

export const StyledTopNavWrapper = styled(Box)(({ theme, hidden }) => `
  display: ${hidden ? 'none' : 'block'};
  position: fixed;
  z-index: ${TOP_NAV_Z_INDEX};
  top: 0;
  left: 0;
  width: 100vw;
  background-color: ${theme.uptimeColors.menuColors.mainMenu?.background ? theme.uptimeColors.menuColors.mainMenu.background : theme.uptimeColors.mainTheme.primary};
`);

export const TopNavWrapperContainer: any = styled(WrapperContainer)`
${( {theme, ...props}: IThemeProps) => `
    display: grid;
    grid-template-areas: 'left left middle middle right right' 'footer footer footer footer footer footer';
    grid-template-columns: auto auto auto;
    gap: ${theme.uptimeSpace[10]}px;
    height: ${TOP_NAV_MOBILE_HEIGHT}px;
    
    .content-left {
      grid-area: middle;
      justify-self: center;
      margin-left: 64px;

      .home-icon {
        display: none;
        color: ${theme.uptimeColors.menuColors.mainMenu?.iconColor || theme.uptimeColors.grayScales.white};
      }
    }
    .content-middle {
      grid-area: footer;
      justify-self: center;
      min-width: 314px;
    }
    .content-right {
      grid-area: right;
      justify-self: right;
    }
    .content-btn-mobile {
      grid-area: left;
      justify-self: left;
      display: flex;
      align-items: center;
      .MuiIconButton-root{
        padding: ${theme.uptimeSpace[0]}px !important;
        margin-left: -${theme.uptimeSpace[1] + 1}px!important;
        color: ${theme.uptimeColors?.menuColors.mainMenu?.iconColor || theme.uptimeColors.grayScales.white};
      }
    }
    @media screen and (min-width: ${theme.breakpoints.md}) {
      display: flex;
      align-items: center;
      height: ${TOP_NAV_HEIGHT}px;

      .content-left {
        margin-left: 0;

        .home-icon {
          display: flex;
          margin-left: ${HOME_BUTTON_MARGIN_X}px;
          margin-right: ${HOME_BUTTON_MARGIN_RIGHT}px;
        }
      }
      .content-middle{
        flex: 2;
        display: flex;
        justify-content: flex-end;
        margin-right: ${theme.uptimeSpace[4]}px;
      }
    }
    @media screen and (min-width: ${theme.breakpoints.lg}) {
      .content-btn-mobile {
        display: none;
      }
    }
`}`;
export const StyledTopNav: any = styled.div`
${( {theme, ...props} : IThemeProps & { hidden?: boolean } & {isSubmenu: boolean}) => `
    display: ${props.hidden ? 'none' : 'flex'};
    height: ${TOP_NAV_MOBILE_HEIGHT}px;
    align-items: center;
    flex-direction: column;
    margin-bottom: 0;
    @media screen and (min-width: ${theme.breakpoints.md}) {
      height: ${TOP_NAV_HEIGHT}px;
    }
    @media screen and (min-width: ${theme.breakpoints.lg}) {
      margin-bottom: ${props.isSubmenu ? TOP_NAV_HEIGHT : 0}px;
    }
    @media print {
      display: none;
    }
    position: relative;
    > .outer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
    }
    .logo {
      > a {
        display: block;
        margin: ${theme.uptimeSpace[0]}px;
        &:hover{
          cursor: pointer;
        }
  
        img {
          display: block;
          height: ${theme.layout.logoHeight ? `${theme.layout.logoHeight}px` : '28px'};
        }
      }
    }
    .title-no-sub {
      display: inline-block;
      align-items: center;
      position: relative;
      height: 54px;
      color: ${theme.uptimeColors.grayScales.white};
      font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
      font-weight: 500 !important;
      white-space: nowrap;
      text-decoration: none;
      &:hover,
      &.expanded {
        cursor: pointer;
        &:before {
          content: "";
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          top: 55px;
          z-index: 1;
          height: 3px;
          background-color: ${theme.uptimeColors.menuColors.mainMenu?.hover ? theme.uptimeColors.menuColors.mainMenu?.hover : theme.uptimeColors.grayScales.white};
        }
      }
      &:active,
      &.expanded {
        &:before{
          background-color: ${theme.uptimeColors.menuColors.mainMenu?.hoverActive ? theme.uptimeColors.menuColors.mainMenu?.hoverActive : theme.uptimeColors.grayScales.white};
          top: 55px;
        }
      }
    }
    .content-left {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .content-right {
      display: flex;
      align-items: center;
      position: relative;
    }

    .list-menu {
      display: none !important;
      align-items: center;
      margin-left: ${LIST_MENU_MARGIN_LEFT}px;
      padding: 0;
      &, ul {
        margin-top: 0;
        margin-bottom: 0;
        list-style: none;
      }
      & > li {
        margin-top: ${theme.uptimeDynamicAlignCenter?.menuItem?.marginTop ?? `${theme.uptimeSpace[1]}px`};
        &:not(:first-of-type) {
          margin-left: ${theme.uptimeSpace[20]}px !important;
          @media (max-width: 1366px) {
            margin-left: ${theme.uptimeSpace[12]}px !important;
          }
          @media (min-width: 1440px) {
            margin-left: ${theme.uptimeSpace[12]}px !important;
          }
        }
      }
      @media (min-width: ${theme.breakpoints.lg}) {
        display: flex !important;
      }
      .
    }
    .flex {
      display: flex;
    }
  `}
`;

interface GroupMenuItemProps {
  expanded: boolean;
  pseudoStyle?: string;
}

export const GroupMenuItem = styled('span')<GroupMenuItemProps>(({ theme, expanded, pseudoStyle = '' }) => `
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 ${GROUP_MENU_ITEM_PADDING_X}px;
  color: ${theme.uptimeColors.menuColors.mainMenu?.textColor || theme.uptimeColors.grayScales.white};
  &::after {
    ${pseudoStyle}
    margin-left: ${theme.uptimeSpace[4]}px;
    margin-right: -${theme.uptimeSpace[4]}px;
    transform: ${expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`);